import { render, staticRenderFns } from "./ProcessInstanceDetails.vue?vue&type=template&id=82290d90&scoped=true"
import script from "./ProcessInstanceDetails.vue?vue&type=script&lang=js"
export * from "./ProcessInstanceDetails.vue?vue&type=script&lang=js"
import style0 from "./ProcessInstanceDetails.vue?vue&type=style&index=0&id=82290d90&prod&scoped=true&lang=css"
import style1 from "./ProcessInstanceDetails.vue?vue&type=style&index=1&id=82290d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82290d90",
  null
  
)

export default component.exports